<template>
  <div class="container">
    <h1>Manage surveys</h1>
    <div class="gridContainer">
      <div v-for="survey in surveys" v-bind:key="survey.code" class="gridItem">
        <h2>{{ survey.title }}</h2>
        <h4>{{ survey.code }}</h4>
        <div class="buttonContainer">
          <button
            class="deleteButton"
            @click="this.$router.push('/delete/' + survey.code)"
          >
            <h3>Delete</h3>
          </button>
          <button
            class="editButton"
            @click="this.$router.push('/edit/' + survey.code)"
          >
            <h3>Edit</h3>
          </button>
          <button @click="this.$router.push('/' + survey.code)">
            <h3>View</h3>
          </button>
        </div>
        <div class="buttonContainer" style="margin-top: 0.5rem">
          <button class="clearButton" @click="openClear(survey.code)">
            <h3>Clear</h3>
          </button>
          <a
            class="resultsButton"
            :href="baseurl + 'submissions' + '?code=' + survey.code"
            target="_blank"
          >
            <h3>Results ({{ resCount[survey.code] || "0" }})</h3>
          </a>
          <button
            @click="this.$router.push('/' + survey.code + '/qr')"
            class="qrButton"
          >
            <h3>QR Code</h3>
          </button>
        </div>
      </div>
      <div class="addRow">
        <button @click="this.$router.push('/add')">
          <h3>Add survey</h3>
        </button>
      </div>
    </div>

    <h1 style="margin-top: 4rem">Manage Scales</h1>
    <div class="gridContainer">
      <div v-for="scale in scales" v-bind:key="scale.id" class="gridItem">
        <h2>{{ scale.name }}</h2>

        <div class="surveycontainer">
          <div class="optionContainer">
            <div
              class="option"
              v-for="(option, index) in scale.options"
              :key="index"
            >
              <h3>{{ option.label }}</h3>
            </div>
          </div>
          <div class="labelContainer">
            <h4 class="llabel">{{ scale.ltext }}</h4>
            <h4 class="clabel">{{ scale.ctext }}</h4>
            <h4 class="rlabel">{{ scale.rtext }}</h4>
          </div>
          <div class="optionSpacing" />
        </div>
        <div class="buttonContainer">
          <div />
          <div />
          <button
            class="deleteButton"
            @click="this.$router.push('/deleteScale/' + scale.id)"
          >
            <h3>Delete</h3>
          </button>
        </div>
      </div>
      <div class="addRow">
        <button @click="this.$router.push('/addScale')">
          <h3>Add scale</h3>
        </button>
      </div>
    </div>
    <div
      style="
        width: 100vw;
        height: 100vh;
        background-color: #00000055;
        backdrop-filter: blur(8px);
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0;
        right: 0;
      "
      v-if="clearOpen !== ''"
    >
      <div
        style="
          width: min(95vw, 700px);
          background-color: #ffffff;
          border-radius: 1rem;
        "
      >
        <div style="margin: 2rem 4rem; color: #000000; text-align: left">
          <h2 style="margin-bottom: 0.4rem">
            Are you sure you want to clear all responses?
          </h2>
          <h4 style="margin-top: 0; color: rgb(216, 18, 18)">
            This cannot be undone.
          </h4>
          <div style="width: 100%; display: flex; justify-content: flex-end">
            <button
              style="background-color: #6c757d; margin-right: 0.8rem"
              @click="closeClear"
            >
              <h3>No</h3>
            </button>
            <button style="background-color: #dc3545" @click="clearResponses">
              <h3>Yes</h3>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    style="
      width: 100vw;
      height: 100vh;
      background-color: #00000055;
      backdrop-filter: blur(8px);
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      top: 0;
      right: 0;
    "
    v-if="showCleared"
  >
    <h1>Cleared!</h1>
  </div>
</template>

<script>
import accountStore from "../accountStore";
import axios from "axios";
import { baseurl } from "../api";

export default {
  methods: {
    updateCounts() {
      axios
        .get(baseurl + "submissionCount", {
          params: { p: accountStore.passcode },
        })
        .then((r) => {
          this.resCount = r.data;
        });
    },
    openClear(code) {
      this.clearOpen = code;
    },
    closeClear() {
      this.clearOpen = "";
    },
    clearResponses() {
      axios.post(baseurl + "clearResponses", {
        code: this.clearOpen,
        p: accountStore.passcode,
      });
      this.showCleared = true;
      this.clearOpen = "";
      setTimeout(() => {
        this.showCleared = false;
      }, 2000);
    },
    submit() {
      const inputobj = document.getElementById("surveycode");
      const usercode = inputobj.value;

      axios.post(baseurl + "checkpasscode", { code: usercode }).then((r) => {
        if (r.data.success) {
          accountStore.login(usercode);
          this.$router.push("/manage");
          return;
        }
        accountStore.logout();
        inputobj.classList.add("errored");
        document.getElementById("errortext").classList.add("shown");
      });
    },
  },
  created() {
    if (!accountStore.verified) {
      this.$router.push("/admin");
    }
    this.updateCounts();
    setInterval(this.updateCounts, 5000);
    axios
      .get(baseurl + "getsurveys", { params: { p: accountStore.passcode } })
      .then((r) => {
        this.surveys = r.data;
      });
    axios
      .get(baseurl + "getscales", { params: { p: accountStore.passcode } })
      .then((r) => {
        this.scales = r.data;
      });
  },
  data() {
    return {
      surveys: {},
      scales: {},
      baseurl: baseurl,
      clearOpen: "",
      showCleared: false,
      resCount: {},
    };
  },
  name: "Management",
};
</script>

<style scoped>
.gridContainer {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

.buttonContainer {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
  margin-top: 1rem;
}

.addRow {
  grid-column-start: 1;
  grid-column-end: 4;
  display: flex;
  margin-top: 1rem;
  justify-content: flex-end;
}

.gridItem {
  border: 1px solid white;
  border-radius: 1rem;
  padding: 1.5rem 2.5rem;
}

.gridItem h4,
h2 {
  text-align: left;
}

.gridItem h4 {
  color: #aaaaaa;
  margin-top: 0.4rem;
  margin-bottom: 0;
  margin-left: 0.1rem;
}

.gridItem h2 {
  margin-top: 0;
  margin-bottom: 0;
}

.container {
  align-self: flex-start;
  margin: 2rem 1rem;
}

input {
  border: 1px solid #555555;
  border-radius: 1rem;
  padding: 1rem 1rem;
  margin: 0 1rem;
  font-size: 1rem;
  font-weight: bold;
  height: 100%;
}

.errored {
  border: 1px solid #ff0000;
}

.errored:focus {
  outline-color: #ff0000;
}

.deleteButton {
  background-color: #dc3545;
}

.resultsButton {
  background-color: #6c757d;
}

.clearButton {
  background-color: #ffc107;
}

.qrButton {
  background-color: #28a745;
}

.editButton {
  background-color: #17a2b8;
}

button {
  background-color: #007bff;
  border: none;
  border-radius: 1rem;
  cursor: pointer;
}

button > h3 {
  color: #ffffff;
  margin: 0.6rem 0.8rem;
}

a {
  background-color: #007bff;
  border: none;
  border-radius: 1rem;
  cursor: pointer;
  text-transform: none;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

a > h3 {
  color: #ffffff;
  margin: 0.6rem 0.8rem;
  font-size: 0.98rem;
}

.inputrow {
  display: flex;
  align-items: center;
}

h5 {
  text-align: left;
  margin: 0.3rem 1.7rem;
  color: #c70000;
  visibility: hidden;
}

.shown {
  visibility: visible;
}

.surveycontainer {
  width: 100%;
}

.optionContainer {
  display: flex;
  width: 100%;
  margin-top: 0.5rem;
  margin-bottom: 0;
}

.optionSpacing {
  margin-bottom: 2rem;
}

.option {
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0.2rem;
  padding: 0;
  border-radius: 1rem;
  transition: 0.25s;
  cursor: not-allowed;
  background-color: #dddddd;
  color: #000010;
}

.option > h3 {
  margin: 0.8rem;
}

.labelContainer {
  position: relative;
  width: 100%;
}

.llabel,
.clabel,
.rlabel {
  position: absolute;
  margin-top: 0.4rem;
}

.llabel {
  left: 0.5rem;
}

.clabel {
  left: 50%;
  transform: translate(-50%, 0);
}

.rlabel {
  right: 0.5rem;
}
</style>
